// extracted by mini-css-extract-plugin
module.exports = {"AuthPanel":"AuthPanel_AuthPanel__2vztg","Content":"AuthPanel_Content__2P5cy"};